import { createFileRoute } from "@tanstack/react-router";
import { LogPage } from "@/components/admin/ai-assistant/log-page";

export const Route = createFileRoute("/admin/ai-assistant/log/")({
	component: LogPage,
});
